import { FeatureSet, ReleaseStage, Stage, Theme } from './types';
// removes/disables all non-prod code and environments if Prod
export const RELEASE = [Stage.Stage, Stage.Local, Stage.Test].includes(import.meta.env.VITE_RELEASE)
    ? import.meta.env.VITE_RELEASE
    : Stage.Prod;
export const STAGE = [Stage.Stage, Stage.Local, Stage.Test].includes(import.meta.env.VITE_STAGE)
    ? import.meta.env.VITE_STAGE
    : Stage.Prod;
export const RELEASE_STAGE = [
    ReleaseStage.Alpha,
    ReleaseStage.Beta,
    ReleaseStage.Gamma,
    ReleaseStage.Internal,
    ReleaseStage.EarlyAccess,
    ReleaseStage.General
].includes(import.meta.env.VITE_RELEASE_STAGE)
    ? import.meta.env.VITE_FEATURESET
    : undefined;
// // these are compile time settings do not change at runtime
export const APP_NAME = import.meta.env.VITE_APP_NAME;
export const APP_VERSION = import.meta.env.VITE_APP_VERSION;
export const AUTHED_BASEPATH = import.meta.env.VITE_AUTHED_BASEPATH;
export const BUY_CRYPTO_URL = import.meta.env.VITE_BUY_CRYPTO_URL;
export const CHAT_CHANNELS = import.meta.env.VITE_CHAT_CHANNELS; // todo: deprecate and move
export const GIPHY_API_KEY = import.meta.env.VITE_GIPHY_API_KEY;
export const INFURA_KEY = import.meta.env.VITE_INFURA_KEY;
export const LATE_FINGERPRINT = import.meta.env.VITE_LATE_FINGERPRINT === 'true';
export const POSTHOG = import.meta.env.VITE_POSTHOG;
export const WALLET_CONNECT = import.meta.env.VITE_WALLET_CONNECT; // move to brand
export const WALLET_CONNECT_ENABLED = import.meta.env.VITE_WALLET_CONNECT_ENABLED === 'true';
// // end compile time settings
// // brand/theme settings
export const THEME = import.meta.env.VITE_THEME
    ? import.meta.env.VITE_THEME
    : undefined;
export const BRAND = import.meta.env.VITE_BRAND;
// staging and feature gating settings
export const AB_TEST = import.meta.env.VITE_AB_TEST;
export const REL = import.meta.env.VITE_REL;
// end staging and feature gating settings
// // manual tweaks/configurations
export const POSTAUTH_NOSESSION_BEHAVIOR = import.meta.env
    .VITE_POSTAUTH_NOSESSION_BEHAVIOR; // todo: deprecate
export const V2_PART = import.meta.env.VITE_V2_PART; // public V2 player V1
// // end
// localhost settings
export const LOCAL_BASE = import.meta.env.VITE_LOCAL_BASE ?? '127.0.0.1';
export const LOCAL_SECURE = import.meta.env.VITE_LOCAL_SECURE === 'true';
export const LOCAL_PORT = parseInt(import.meta.env.VITE_LOCAL_PORT ?? 8000);
export const REALM = import.meta.env.VITE_REALM;
// // end
